/*
 * 统一配置各个微服务的服务名
 * */
/**
 * 通过网关访问
 */
const dev = {
  order: '/order',  //订单服务
  oauth: '/oauth', //认证服务
  rbac: '/rbac', // rbac
  pay: '/pay',
  member: '/member',
  ops: '/ops',
  charge: '/charge',
  ict: '/ict',
  notice: '/notice',
  redis: '/redis',
  res: '/res',
  search: '/search',
  sett: '/settlement',
  loggrab: '/loggrab',
  rule: '/rule',
  profit: '/profit', //  分润服务
  vip: '/vip', //  会员服务
  lock: '/lock' // 地锁服务
};
/**
 * 本地访问
 */
const local = {
  order: ':2019',  //订单服务
  oauth: ':9102', //认证服务
  rbac: ':9101', // rbac
  pay: ':2017',
  member: ':2016',
  ops: ':2021',
  charge: ':2015',
  ict: ':2028',
  notice: ':2219',
  redis: ':2014',
  res: ':2022',
  search: ':2020',
  sett: ':2018',
  loggrab: ':6000',
  profit: ':2052', //  分润服务
  vip: ':2051'  //  会员服务
};

let serviceList = dev
module.exports = serviceList



//////////////////
// WEBPACK FOOTER
// ./config/serviceList.js
// module id = HR24
// module chunks = 63